import _toNumber from 'lodash.tonumber';

export function toNumber(value: string | number | boolean): number {
  return _toNumber(value);
}
